import { useEffect, useRef, useState } from 'react'
import { TeacherSession } from 'common/utils/types/teacher-session'
import { TeacherInstance } from 'common/utils/types/account-types'
import api from 'common/services/api'
import useTeacherSession from './useTeacherSession'

export default function useGetCurrentUser() {
  const [currentTeacher, setCurrentTeacher] = useState<TeacherInstance>()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { session: teacherSession, refreshSession }: any = useTeacherSession()
  // used for prevnting multiple initializations
  const loading = useRef<boolean>(false)

  const fetchTeacher = () => {
    loading.current = true
    api({
      url: '/api2/refresh',
      method: 'POST',
      data: {
        teachers: {
          [teacherSession.code]: { version: 0, secret: teacherSession.secret },
        },
        classrooms: {},
        students: {},
      },
    })
      .then((response) => {
        setCurrentTeacher(response.data.teachers.items[teacherSession.code])
        loading.current = false
      })
      .catch((err) => console.error(err))
  }

  useEffect(() => {
    if (loading.current || !teacherSession) return
    fetchTeacher()
  }, [teacherSession])

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || !event.data) {
        return
      }

      switch (event.data.type) {
        case 'awakeningStepperAction': {
          if (event.data.status === 'success') {
            fetchTeacher()
            if (window.parent.location.href.indexOf('awakening') > -1) {
              const closeButton = window.parent.document.querySelector(
                '#awakeningPopup .closeIcon'
              ) as HTMLElement
              closeButton.click()
            }
          }
          break
        }
        case 'teacher-signed-in':
          if (event.data.teacher !== teacherSession?.code) refreshSession()
          break
        case 'resetStepperModal':
          // being handled in stepper file
          break
        default:
          console.log('unknown message', event.data)
      }
    }

    window.parent.addEventListener('message', handleMessage)
    return () => {
      window.parent.removeEventListener('message', handleMessage)
    }
  }, [fetchTeacher])

  return currentTeacher
}
